import { useNavigate } from "react-router-dom";

import "../../assets/css/categoryCard.css";

function CategoryCard({ title, image, path }) {

    const navigate = useNavigate();

    return (

        <article className="luxury-category-card">

            <img
                src={image}
                alt={title}
                className="luxury-category-image"
            />

            <div className="luxury-category-overlay">

                <div className="luxury-category-top">

                    <span>STORY LINE STUDIOS</span>

                </div>

                <div className="luxury-category-content">

                    <h2>{title}</h2>

                    <div className="luxury-divider"></div>

                    <p>
                        Every frame tells a timeless story with elegance,
                        creativity and cinematic beauty.
                    </p>

                    <div className="luxury-category-buttons">

                        <button
                            type="button"
                            className="luxury-btn luxury-photo-btn"
                            onClick={() => navigate(`${path}?type=photos`)}
                        >
                            📷 View Photos
                        </button>

                        <button
                            type="button"
                            className="luxury-btn luxury-video-btn"
                            onClick={() => navigate(`${path}?type=videos`)}
                        >
                            🎥 Watch Videos
                        </button>

                    </div>

                </div>

            </div>

           

        </article>

    );

}

export default CategoryCard;